import { inject, provideAppInitializer } from '@angular/core';
import { confidentialityStore } from './confidentiality.store';

export interface ConfidentialityOptions {
  checkSessionStatus?: boolean;
}

export function provideConfidentiality(options: ConfidentialityOptions = {}) {
  return [
    provideAppInitializer(() => {
      // Accessing the store triggers its creation and the onInit hook
      inject(confidentialityStore);
    }),
  ];
}
